<mat-dialog-content class="position-relative">
    @if (isLoading()) {
        <div class="loading-container">
            <mat-spinner [diameter]="32" />
        </div>
    }
    @if (cameraPermission() !== 'ok') {
        <div class="h-100 d-flex flex-column align-items-center justify-content-center text-center">
            <mat-error>
                {{
                    (cameraPermission() === 'dismissed'
                        ? 'BarcodeScanner.CameraPermissionDismissed'
                        : 'BarcodeScanner.CameraPermissionBlocked'
                    ) | translate
                }}
            </mat-error>
            @if (cameraPermission() === 'dismissed') {
                <button type="button" mat-button (click)="initialize()">
                    {{ 'BarcodeScanner.AskAgain' | translate }}
                </button>
            }
        </div>
    }
    <div #barcodeScannerContainer class="barcode-scanner-container" [class.hidden]="isLoading() || cameraPermission() !== 'ok'"></div>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button mat-dialog-close>{{ 'General.Cancel' | translate }}</button>
</mat-dialog-actions>
